import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import { Dropdown } from "react-bootstrap";
import { usePrices } from "../../../context/SocketContext";

import { getAllCoins, fetchCoinsForSelect } from "../../../api/coin";
import {
  createExchangeTransaction,
  getExchangeHistory,
} from "../../../api/transaction";
import Swal from "sweetalert2";

const Exchange = () => {
  const [coinsOptions, setCoinsOptions] = useState([]);
  const [selectCoinsOptions, setSelectCoinsOptions] = useState([]);
  const [fromQty, setFromQty] = useState("");
  const [fromCoin, setFromCoin] = useState(null); // { value, label }
  const [toCoin, setToCoin] = useState(null); // { value, label }
  const [tableData, setTableData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const limit = 10;

  const prices = usePrices();

  useEffect(() => {
    async function fetchHistory() {
      try {
        const data = await getExchangeHistory(currentPage, limit);
        setTableData(data); // assuming API returns { data: [...], total: n }
        setTotalRecords(data.total || 0);
        setTotalPages(Math.ceil((data.total || 0) / limit));
      } catch (err) {
        console.error(err);
      }
    }
    fetchHistory();
  }, [currentPage]);

  useEffect(() => {
    async function fetchCoins() {
      try {
        const data = await getAllCoins(1, 1000);
        console.log("DATA", data);

        const formattedCoins = data.data.map((coin) => ({
          value: coin?.id,
          label: coin?.symbol || coin?.name,
        }));

        setCoinsOptions(formattedCoins);
        console.log("Set coins options", coinsOptions);
      } catch (error) {
        console.error("Failed to load coins", error);
      }
    }

    async function fetchSelectableCoins() {
      try {
        const data = await fetchCoinsForSelect();
        console.log("dataN", data);
        const formatted = data.map((item) => ({
          value: item?.coin?.id,
          label: item?.coin?.symbol || item?.coin?.name,
        }));
        setSelectCoinsOptions(formatted);
        console.log("Set selected coins", selectCoinsOptions);
      } catch (error) {
        console.error("Failed to load selectable coins", error);
      }
    }

    fetchCoins();
    fetchSelectableCoins();
  }, []);

  const handleExchange = async () => {
    if (!fromCoin || !toCoin || !fromQty) {
      Swal.fire({
        icon: "warning",
        title: "Oops...",
        text: "Please fill in all fields.",
      });
      return;
    }

    const data = {
      fromTokenId: fromCoin.value,
      toTokenId: toCoin.value,
      quantity: parseFloat(fromQty),
    };

    try {
      const response = await createExchangeTransaction(data);
      console.log("RESPONSE Status", response);

      if (response === 200 || response === 201) {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "Exchange transaction successful!",
        });

        // ✅ Re-fetch exchange history after successful transaction
        const updatedHistory = await getExchangeHistory();
        setTableData(updatedHistory);

        // Optional: clear inputs
        setFromQty(0);
        setFromCoin(null);
        setToCoin(null);
      } else {
        Swal.fire({
          icon: "error",
          title: "Failed",
          text: "Exchange failed. Please try again.",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text:
          error.response?.data?.message ||
          error.message ||
          "Error during exchange.",
      });
    }
  };

  const checkboxFun = (type) => {
    setTimeout(() => {
      const checkbox = document.querySelectorAll(".exchange-history input");
      const motherCheckBox = document.querySelector(".sorting_select input");
      for (let i = 0; i < checkbox.length; i++) {
        const element = checkbox[i];
        if (type === "all") {
          if (motherCheckBox.checked) {
            element.checked = true;
          } else {
            element.checked = false;
          }
        } else {
          if (!element.checked) {
            motherCheckBox.checked = false;
            break;
          } else {
            motherCheckBox.checked = true;
          }
        }
      }
    }, 200);
  };

  return (
    <>
      <div className="row">
        <div className="col-xl-12">
          <div className="card">
            <div className="card-body pb-2">
              <h1 className="text-center no-border font-w600 fs-60 mt-2">
                <span className="text-warning">Buy</span> and{" "}
                <span className="text-danger">Sell</span> Coins at the
                <br /> Pinance with no additional charges
              </h1>
              <h4 className="text-center ">
                Trusted by millions user with over $1 Billion in crypto
                transactions.
              </h4>
              <div className="row">
                <div className="col-xl-12">
                  <div className="text-center mt-3 row justify-content-center">
                    <div className="col-xl-5">
                      <div className="row">
                        <div className="col-xl-6">
                          <Select
                            className="custom-react-select mb-xl-0 mb-3"
                            options={selectCoinsOptions}
                            value={fromCoin}
                            onChange={(selected) => setFromCoin(selected)}
                            isSearchable={false}
                          />
                        </div>
                        <div className="col-xl-6">
                          <input
                            type="number"
                            className="form-control mb-3"
                            placeholder="Enter Quantity"
                            value={fromQty}
                            onChange={(e) => setFromQty(e.target.value)}
                          />
                        </div>
                      </div>
                    </div>
                    <div className=" col-xl-1">
                      <div className="equalto">=</div>
                    </div>
                    <div className="col-xl-5">
                      <div className="row">
                        <div className="col-xl-6">
                          <Select
                            className="custom-react-select mb-xl-0 mb-3"
                            options={coinsOptions}
                            value={toCoin}
                            onChange={(selected) => setToCoin(selected)}
                            isSearchable={true}
                          />
                        </div>
                        <div className="col-xl-6">
                          <input
                            disabled
                            type="number"
                            className="form-control mb-3"
                            placeholder="Live Quantity"
                            value={
                              fromQty &&
                              prices?.find(
                                (coin) => coin.coinId === toCoin?.value
                              )?.price
                                ? (
                                    fromQty /
                                    prices.find(
                                      (coin) => coin.coinId === toCoin?.value
                                    ).price
                                  ).toFixed(8)
                                : 0
                            }
                            readOnly
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="text-center mt-4 mb-4">
                    <button
                      className="btn btn-warning mx-auto"
                      onClick={handleExchange}
                    >
                      EXCHANGE NOW
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-12">
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-header justify-content-start border-0">
                  <h2 className="heading mb-0">Exchange Transactions</h2>
                </div>
                <div className="card-body px-0 py-0">
                  <div className="table-responsive">
                    <table
                      className="exchange-history table-responsive table shadow-hover tickettable display mb-4 dataTablesCard dataTable no-footer"
                      id="example6"
                    >
                      <thead>
                        <tr>
                          <th className="fs-14 font-w600 border-0 ps-4">
                            Buy Coin
                          </th>
                          <th className="fs-14 font-w600 border-0">
                            Sell Coin
                          </th>
                          <th className="fs-14 font-w600 border-0">Date</th>
                          <th className="fs-14 font-w600 border-0">
                            Buy Price
                          </th>
                          <th className="fs-14 font-w600 border-0">
                            Buy Quantity
                          </th>
                          <th className="fs-14 font-w600 border-0">
                            Sell Price
                          </th>
                          <th className="fs-14 font-w600 border-0">
                            Sell Quantity
                          </th>
                        </tr>
                      </thead>

                      <tbody>
                        {tableData.map((data, index) => (
                          <tr key={index}>
                            <td>
                              <strong>{data?.buy?.coin?.symbol}</strong>
                              <br />
                              {/* <small>{data?.buy?.coin?.name}</small> */}
                            </td>
                            <td>
                              <strong>{data?.sell?.coin?.symbol}</strong>
                              <br />
                              {/* <small>{data?.sell?.coin?.name}</small> */}
                            </td>
                            <td>{new Date(data.date).toLocaleString()}</td>
                            <td>{data?.buy?.price}</td>
                            <td>{data?.buy?.quantity}</td>
                            <td>{data?.sell?.price}</td>
                            <td>{data?.sell?.quantity}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <div className="table-pagenation d-flex align-items-center justify-content-between mb-3">
                    <p className="mb-0">
                      Showing <span> 1-4 </span> from <span> 30 </span> data{" "}
                    </p>
                    <nav>
                      <ul className="pagination pagination-gutter pagination-primary no-bg">
                        {/* Previous arrow */}
                        <li
                          className={`page-item page-indicator ${
                            currentPage === 1 ? "disabled" : ""
                          }`}
                        >
                          <button
                            className="page-link"
                            onClick={() =>
                              setCurrentPage((prev) => Math.max(prev - 1, 1))
                            }
                            disabled={currentPage === 1}
                          >
                            <i className="fa-solid fa-angle-left"></i>
                          </button>
                        </li>

                        {/* Page numbers */}
                        {[...Array(totalPages).keys()].map((page) => (
                          <li
                            key={page + 1}
                            className={`page-item ${
                              currentPage === page + 1 ? "active" : ""
                            }`}
                          >
                            <button
                              className="page-link"
                              onClick={() => setCurrentPage(page + 1)}
                            >
                              {page + 1}
                            </button>
                          </li>
                        ))}

                        {/* Next arrow */}
                        <li
                          className={`page-item page-indicator ${
                            currentPage === totalPages ? "disabled" : ""
                          }`}
                        >
                          <button
                            className="page-link"
                            onClick={() =>
                              setCurrentPage((prev) =>
                                Math.min(prev + 1, totalPages)
                              )
                            }
                            disabled={currentPage === totalPages}
                          >
                            <i className="fa-solid fa-angle-right"></i>
                          </button>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Exchange;
